"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMobileWall = void 0;
var _react = require("react");
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _styles = require("@material-ui/core/styles");
var _mobileDetect = _interopRequireDefault(require("mobile-detect"));
var useMobileWall = exports.useMobileWall = function useMobileWall() {
  var theme = (0, _styles.useTheme)();
  var matches = (0, _useMediaQuery["default"])(theme.breakpoints.down('xs'), {
    noSsr: true
  });
  var isMobile = (0, _react.useMemo)(function () {
    var md = new _mobileDetect["default"](window.navigator.userAgent);
    return Boolean(md.phone());
  }, []);
  return isMobile || matches;
};
//# sourceMappingURL=responsive.js.map